export default __webpack_public_path__ + "static/media/logobpo.09e54a52.png";